import { r as containerShortcuts } from "./container-m1WfKD7R.mjs";
//#region src/shortcuts/index.ts
const shortcuts = [...containerShortcuts];
//#endregion
export { shortcuts };
